export const checkHasBrandingData = (brandingData) => {
  const brandingDataKeys = Object.keys(brandingData ?? {});
  return (
    brandingDataKeys.length > 1 ||
    (brandingDataKeys.length === 1 &&
      brandingDataKeys[0] !== 'networkAutoMigrateCcms')
  );
};
